import { createSelector } from "reselect";

import type { CrmColumnItem } from "app/pages/sales-intelligence/sub-modules/management/types";
import { createStatePropertySelector } from "app/pages/workspace/sales/helpers";
import type { RootState } from "single-spa/store/types";

import { selectSalesIntelligenceState } from "../../../store/selectors";

const selectCrmEnrichmentState = selectSalesIntelligenceState("crmEnrichment");

const select = createStatePropertySelector(selectCrmEnrichmentState);

export const selectIsRenameModalOpen = select("isRenameModalOpen");

export const selectIsRemoveModalOpen = select("isRemoveModalOpen");

export const selectJobName = select("jobName");

export const selectSelectedJobType = select("selectedJobType");

export const selectSelectedJobObject = select("selectedJobObject");

export const selectSelectedJobRefreshPeriod = select("selectedJobRefreshPeriod");

export const selectSelectedCountryId = select("selectedCountryId");

export const selectSelectedEnrichmentSource = select("selectedEnrichmentSource");

export const selectSelectedLeadScoreRefreshDataInterval = select("selectedLeadScoreRefreshDataInterval");

export const selectWizardFilters = select("wizardFilters");

export const selectJobState = createSelector(
    [
        selectJobName,
        selectSelectedJobType,
        selectSelectedJobObject,
        selectSelectedJobRefreshPeriod,
        selectSelectedLeadScoreRefreshDataInterval,
        selectSelectedCountryId,
        selectSelectedEnrichmentSource,
    ],
    (jobName, jobType, jobObject, refreshPeriod, leadScoreRefreshDataInterval, countryId, enrichmentSource) => ({
        jobName,
        jobType,
        jobObject,
        refreshPeriod,
        leadScoreRefreshDataInterval,
        countryId,
        enrichmentSource,
    }),
);

export const selectMappings = select("mappings");

export const selectFilters = createSelector(selectWizardFilters, (wizardFilters) => wizardFilters.filters);

export const createCrmFieldOptionsSelector = (columnsSelector: (state: RootState) => readonly CrmColumnItem[]) =>
    createSelector([selectFilters, columnsSelector], (filters, columns): readonly string[] => {
        const usedFields = new Set(filters.map((f) => f.field));

        return columns.map((c) => c.label).filter((label) => !usedFields.has(label));
    });
